import Model from './Model'

export default class FoodCategory extends Model {
  resource() {
    return 'settings/food-categories'
  }
}
